import { useDeptManagerCreate } from "services";
import { useOrgChartHook } from "stores/OrgChart";
import { i18n } from "translations";
import * as Yup from "yup";

const EmployeeFormSchema = Yup.object({
  employee: Yup.object()
    .shape({
      label: Yup.string().required(i18n.t("employeeIsRequired")),
      value: Yup.string().required(i18n.t("employeeIsRequired")),
    })
    .required(i18n.t("employeeIsRequired")),
  role: Yup.string().required(i18n.t("roleIsRequired")),
  roleTitle: Yup.string().notRequired(),
});

type EmployeeForm = Yup.InferType<typeof EmployeeFormSchema>;

export const useEmployeeDialog = ({ onToggle }: { onToggle: () => void }) => {
  const { nodeSelected, addDeptManager } = useOrgChartHook();
  const { mutate: createEmployee, isLoading } = useDeptManagerCreate({
    queryKey: "deptEmployeeCreateHook",
    options: {
      onSuccess: (res) => {
        if (nodeSelected?.id) {
          addDeptManager(nodeSelected.id, [res.data]);
          onToggle();
        }
      },
    },
  });

  const handleSubmit = (data: EmployeeForm) => {
    if (nodeSelected?.id) {
      createEmployee({
        departmentId: Number(nodeSelected?.id ?? 0),
        employeeId: Number(data.employee.value ?? 0),
        role: data.role,
        roleTitle: String(data.roleTitle ?? ""),
      });
    }
  };

  return {
    EmployeeFormSchema,
    nodeSelected,
    loading: isLoading,
    handleSubmit,
  };
};
